import { useDispatch, useSelector } from 'react-redux';
import { eventTypeActions, eventTypeNameSpace, eventTypeSelectors } from '../';
import { toggleModal } from 'reducers/ui';
import React, { useCallback, useEffect } from 'react';
import BaseDetails from 'containers/Base/BaseDetails.js';
import PropTypes from 'prop-types';

const EventTypeDetails = ({ id, cancel, toggleEditMode }) => {
  const dispatch = useDispatch();
  const details = useSelector(state =>
    eventTypeSelectors.getEventTypeTransformed(state),
  );
  const loading = useSelector(state => state.ui.loading);
  const setEventTypeID = useCallback(
    id => {
      dispatch(eventTypeActions.setSelectedRowID(id));
    },
    [dispatch],
  );
  const removeEventTypeDetails = useCallback(
    () => dispatch(eventTypeActions.setGridRowDetails({ details: null })),
    [dispatch],
  );
  const dispatchFetchEventTypeDetails = useCallback(
    id => dispatch(eventTypeActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(eventTypeNameSpace)),
    [dispatch],
  );
  const forceRefresh = useSelector(state =>
    eventTypeSelectors.getForceRefresh(state),
  );
  useEffect(() => {
    if (id || forceRefresh) {
      dispatchFetchEventTypeDetails(id);
      setEventTypeID(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, forceRefresh]);
  const onEdit = () => {
    toggleEditMode();
    dispatchToggleModal(eventTypeNameSpace);
  };
  const cancelAndRemoveDetails = () => {
    cancel();
    setEventTypeID(null);
    removeEventTypeDetails();
  };
  const checkIfEditable = details =>
    !details?.generalInfo?.systemRequired.value;
  return (
    <BaseDetails
      header={'Event Type Details'}
      details={details}
      cancel={cancelAndRemoveDetails}
      editable={checkIfEditable(details)}
      onEdit={onEdit}
      loading={loading}
    />
  );
};
EventTypeDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  toggleEditMode: PropTypes.func,
};
export default EventTypeDetails;
